import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=74b3c728&scoped=true"
import script from "./ProductShare.vue?vue&type=script&lang=ts"
export * from "./ProductShare.vue?vue&type=script&lang=ts"
import style0 from "./ProductShare.vue?vue&type=style&index=0&id=74b3c728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3c728",
  null
  
)

export default component.exports